import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { ProfessionnelItem } from "src/app/professionnel/core/model/professionnel-item";
import { ConditionProfessionnel } from "src/app/professionnel/core/model/condition-professionnel";
import { ProfessionnelItemService } from "src/app/professionnel/core/service/professionnel-item.service";
import { ConditionProfessionnelService } from "src/app/professionnel/core/service/condition-professionnel.service";

@Component({
  selector: "app-form-add-condition",
  templateUrl: "./form-add-condition.component.html",
  styleUrls: ["./form-add-condition.component.scss"],
})
export class FormAddConditionComponent implements OnInit {
  @Input() professionnelItemId;

  requestId: number;

  professionnelItem: ProfessionnelItem;
  condition: ConditionProfessionnel = new ConditionProfessionnel();

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _professionnelItemService: ProfessionnelItemService,
    private _conditionProfessionnelService: ConditionProfessionnelService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      libelle: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getProfessionnelItemById(this.professionnelItemId);
  }

  getProfessionnelItemById(professionnelItemId) {
    this._professionnelItemService
      .getProfessionnelItemById(professionnelItemId)
      .subscribe(
        (data) => {
          this.professionnelItem = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  save(): void {
    this.spinner.show();
    const dateTime = new Date().getTime();

    this.condition.professionnelItem = this.professionnelItem;
    this.condition.code = "condition_" + dateTime;
    this.condition.checked = true;

    this._conditionProfessionnelService
      .postConditionProfessionnel(this.condition)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
